
import { Collapse } from "antd";
import HeroContainer from "../components/common/HeroContainer";
import VSpace from "../components/common/VSpace";
import SurveyFeedbackButton from "../components/Dashboard/SurveyFeedbackButton";
import InvoiceReport from "../components/Datacenter/InvoiceReport/InvoiceReport";
import ItemsReport from "../components/Datacenter/ItemsReport/ItemsReport";
import ProposalsReport from "../components/Datacenter/ProposalsReport/ProposalsReport";
import useFeatureFlag from "../hooks/useFeatureFlag";
import VisitNotesReport from "../components/Datacenter/VisitNotesReport/VisitNotesReport";
import ManHoursReport from "../components/Datacenter/ManHours/ManHoursReport";
import EstimatesReport from "../components/Datacenter/EstimatesReport/EstimatesReport";

export type Props = {
  imgSrc: string
}

const DatacenterPage = ({ imgSrc }: Props) => {
  const showData = useFeatureFlag('dashboard-not-ready');
  return <div id="main" className={"main-dashboard fluid-container"}>
    <HeroContainer imgSrc={imgSrc} />
    <div className="hero-details">
      <h1>Datacenter</h1>
    </div>
    <section>
    <VSpace>
    This datacenter page is an experimental playground environment.  We encourage sharing your feedback as we work towards meaningful data insights.
    <SurveyFeedbackButton intercomSurveyId={44829664} />
    <Collapse
      accordion
      items={[
        {
          key: '1',
          label: 'Items Usage',
          children: <ItemsReport />
        },
        {
          key: '10',
          label: 'Invoicing',
          children: <InvoiceReport />,
        },
        {
          key: '30',
          label: 'Labor Metrics',
          children: <ManHoursReport />,
        },
        {
          key: '20',
          label: 'Proposal Summary',
          children: <ProposalsReport />,
        },
        {
          key: '50',
          label: 'Visit Notes',
          children: <VisitNotesReport />,
        },
        ...(showData ? [{
          key: '60',
          label: 'Estimates',
          children: <EstimatesReport />,
        }] : [] ),
      ]} />
  </VSpace>
  </section>
  </div>
}

export default DatacenterPage
